import styled from 'styled-components';

export const Centered = styled.div`
  text-align: center;
`;
